var key = 'history';
export var clearHistory = function () {
    sessionStorage.removeItem(key);
};
export var getHistory = function () {
    var history = sessionStorage.getItem(key);
    return history ? JSON.parse(history) : [];
};
export var saveHistory = function (history) {
    sessionStorage.setItem(key, JSON.stringify(history));
};
export var addToHistory = function (value) {
    var history = getHistory();
    if (history.length > 0 && history[history.length - 1] === value) {
        return;
    }
    history.push(value);
    saveHistory(history);
};
export var getPreviousHistory = function () {
    var history = getHistory();
    if (history.length < 2) {
        return null;
    }
    history.pop();
    var previousUrl = history.pop() || null;
    saveHistory(history);
    return previousUrl;
};
